import stringify from "fast-json-stable-stringify";

// JSON-LD blocks are injected with dangerouslySetInnerHTML, so a "<" coming
// from product data (a "</script>" inside a product name or description) would
// close the script element early and make the whole block unparsable for
// crawlers, besides letting the markup run in the browser. These characters
// are only ever part of JSON string values, where the escaped form is
// equivalent, so escaping them keeps the JSON valid and the page safe.
const HTML_UNSAFE_ESCAPES = {
  "<": "\\u003c",
  ">": "\\u003e",
  "&": "\\u0026",
};

const serializeSchema = (schema) =>
  stringify(schema).replace(
    /[<>&]/g,
    (character) => HTML_UNSAFE_ESCAPES[character]
  );

export default serializeSchema;
